(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mn-delivery')) {
    customElements.define(
      'mn-delivery',
      class extends HTMLElement {
        connectedCallback() {
          this.render();
          this.timer = setInterval(() => this.render(), 60000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        working(date) {
          const d = date.getDay();
          if (d === 0) return false;
          if (d === 6) return this.dataset.saturday === 'true';
          return true;
        }

        addWorking(date, days) {
          const d = new Date(date);
          let left = days;
          while (left > 0) {
            d.setDate(d.getDate() + 1);
            if (this.working(d)) left -= 1;
          }
          return d;
        }

        render() {
          const now = new Date();
          const cutoff = Number(this.dataset.cutoff);
          const lang = this.dataset.lang || 'tr';
          let ship = new Date(now);
          const today = this.working(now) && now.getHours() < cutoff;
          if (!today) {
            do {
              ship.setDate(ship.getDate() + 1);
            } while (!this.working(ship));
          }
          const from = this.addWorking(ship, Number(this.dataset.min) || 1);
          const to = this.addWorking(ship, Number(this.dataset.max) || 3);
          const fmt = (d) => d.toLocaleDateString(lang, { day: 'numeric', month: 'long', weekday: 'short' });
          let shipText;
          if (today) {
            const end = new Date(now);
            end.setHours(cutoff, 0, 0, 0);
            const mins = Math.max(0, Math.round((end - now) / 60000));
            const time = `${Math.floor(mins / 60)} sa ${mins % 60} dk`;
            shipText = this.dataset.today.replace('[time]', time);
          } else {
            shipText = this.dataset.tomorrow.replace('[day]', ship.toLocaleDateString(lang, { weekday: 'long' }));
          }
          this.querySelector('[data-de-ship]').innerHTML = shipText;
          this.querySelector('[data-de-range]').innerHTML = this.dataset.range.replace('[from]', fmt(from)).replace('[to]', fmt(to));
          this.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-recipient"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mn-gift-recipient')) {
    customElements.define(
      'mn-gift-recipient',
      class extends HTMLElement {
        connectedCallback() {
          const toggle = this.querySelector('[data-gcr-toggle]');
          const fields = this.querySelector('[data-gcr-fields]');
          const date = this.querySelector('[data-gcr-date]');
          const today = new Date();
          date.min = today.toISOString().slice(0, 10);
          const max = new Date(today.getTime() + 90 * 86400000);
          date.max = max.toISOString().slice(0, 10);
          this.querySelector('[data-gcr-offset]').value = String(new Date().getTimezoneOffset() * -60);
          toggle.addEventListener('change', () => {
            fields.hidden = !toggle.checked;
            fields.querySelectorAll('input, textarea').forEach((el) => {
              el.disabled = !toggle.checked;
            });
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["installments"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mn-installments')) {
    customElements.define(
      'mn-installments',
      class extends HTMLElement {
        connectedCallback() {
          this.banks = (this.dataset.source || '')
            .split('\n')
            .map((line) => line.trim())
            .filter((line) => line.includes(':'))
            .map((line) => {
              const [name, rest] = [line.slice(0, line.indexOf(':')).trim(), line.slice(line.indexOf(':') + 1)];
              const rows = rest
                .split(',')
                .map((part) => part.split('=').map((x) => x.trim()))
                .filter((p) => p.length === 2 && Number(p[0]) > 0)
                .map(([n, r]) => ({ n: Number(n), rate: Number(r.replace(',', '.')) || 0 }));
              return { name, rows };
            })
            .filter((b) => b.rows.length);
          this.active = 0;
          const product = this.closest('mn-product');
          if (product) {
            product.addEventListener('variant:change', (event) => {
              this.dataset.price = event.detail.price;
              this.render();
            });
          }
          this.render();
        }

        applyMoney(value) {
          const open = String.fromCharCode(123, 123);
          const close = String.fromCharCode(125, 125);
          const format = this.dataset.money || 'amount';
          const re = new RegExp(open.replace(/./g, '\\$&') + '\\s*amount[a-z_]*\\s*' + close.replace(/./g, '\\$&'));
          return re.test(format) ? format.replace(re, value) : value;
        }

        money(cents) {
          const value = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          return this.applyMoney(value);
        }

        render() {
          if (!this.banks || this.banks.length === 0) return;
          const tabs = this.querySelector('[data-it-tabs]');
          tabs.innerHTML = '';
          this.banks.forEach((bank, i) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'it-tab' + (i === this.active ? ' on' : '');
            btn.setAttribute('role', 'tab');
            btn.setAttribute('aria-selected', i === this.active ? 'true' : 'false');
            btn.textContent = bank.name;
            btn.addEventListener('click', () => {
              this.active = i;
              this.render();
            });
            tabs.appendChild(btn);
          });
          const price = Number(this.dataset.price) || 0;
          const bank = this.banks[this.active];
          const rows = bank.rows
            .map((r) => {
              const total = Math.round(price * (1 + r.rate / 100));
              return `<tr><td>${r.n}</td><td>${this.money(Math.round(total / r.n))}</td><td>${this.money(total)}</td></tr>`;
            })
            .join('');
          this.querySelector('[data-it-table]').innerHTML = `<table class="it-table"><thead><tr><th>${this.dataset.lN}</th><th>${this.dataset.lMonth}</th><th>${this.dataset.lTotal}</th></tr></thead><tbody>${rows}</tbody></table>`;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mn-swatches')) {
    customElements.define(
      'mn-swatches',
      class extends HTMLElement {
        connectedCallback() {
          const card = this.closest('.pc');
          const img = card.querySelector('[data-pc-img]');
          const links = card.querySelectorAll('[data-pc-link]');
          const name = this.querySelector('[data-swatch-name]');
          this.querySelectorAll('.pc-swatch').forEach((sw) => {
            const show = () => {
              this.querySelectorAll('.pc-swatch').forEach((x) => x.classList.toggle('on', x === sw));
              if (img && sw.dataset.img) {
                img.removeAttribute('srcset');
                img.src = sw.dataset.img;
                if (sw.dataset.srcset) img.srcset = sw.dataset.srcset;
              }
              links.forEach((link) => (link.href = sw.getAttribute('href')));
              if (name) name.textContent = sw.dataset.name;
            };
            sw.addEventListener('mouseenter', show);
            sw.addEventListener('focus', show);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mn-search')) {
    customElements.define(
      'mn-search',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input[type="search"]');
          this.results = this.querySelector('.mn-search-results');
          this.timer = null;
          this.input.addEventListener('input', () => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.search(), 250);
          });
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) setTimeout(() => (this.results.hidden = true), 150);
          });
          this.input.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') this.results.hidden = true;
          });
        }

        search() {
          const q = this.input.value.trim();
          if (q.length < 2) {
            this.results.hidden = true;
            return;
          }
          const url = `${this.dataset.url}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6&section_id=predictive-search`;
          fetch(url)
            .then((res) => res.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const body = doc.querySelector('[data-predictive]');
              this.results.innerHTML = body ? body.innerHTML : '';
              this.results.hidden = !body;
            })
            .catch(() => {
              this.results.hidden = true;
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mn-size-finder')) {
    customElements.define(
      'mn-size-finder',
      class extends HTMLElement {
        connectedCallback() {
          this.trigger = this.querySelector('.sf-trigger');
          this.panel = this.querySelector('.sf-panel');
          this.texts = {};
          this.querySelectorAll('[data-sf-text]').forEach((el) => {
            this.texts[el.dataset.sfText] = el.textContent.trim();
          });
          this.trigger.addEventListener('click', () => {
            const open = this.trigger.getAttribute('aria-expanded') === 'true';
            this.trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
            this.panel.hidden = open;
          });
          this.querySelector('[data-sf-calc]').addEventListener('click', () => this.calculate());
          this.querySelector('[data-sf-select]').addEventListener('click', () => this.selectSize());
        }

        range(text) {
          const nums = String(text || '')
            .split(/[-–]/)
            .map((n) => parseFloat(n.replace(',', '.')))
            .filter((n) => !Number.isNaN(n));
          if (nums.length === 0) return null;
          return [nums[0], nums[nums.length - 1]];
        }

        value(name) {
          const el = this.querySelector(`[data-sf="${name}"]`);
          const n = parseFloat(String(el.value).replace(',', '.'));
          return Number.isNaN(n) ? null : n;
        }

        weights() {
          const t = this.texts.type || '';
          const has = (words) => words.some((w) => t.includes(w));
          if (has(['tunik', 'bluz', 'gömlek', 'gomlek', 'ceket', 'sweat', 'kazak', 'shirt', 'jacket', 'top']))
            return { bust: 1.65, waist: 0.75, hip: 0.55 };
          if (has(['etek', 'pantolon', 'şort', 'sort', 'skirt', 'pant', 'trouser', 'short']))
            return { bust: 0.15, waist: 1.35, hip: 1.65 };
          if (has(['elbise', 'dress'])) return { bust: 1.25, waist: 1.15, hip: 1.25 };
          return { bust: 1, waist: 1, hip: 1 };
        }

        calculate() {
          const rows = [...this.querySelectorAll('[data-sf-row]')].map((tr) => ({
            el: tr,
            label: tr.dataset.sfRow,
            bust: this.range(tr.dataset.bust),
            waist: this.range(tr.dataset.waist),
            hip: this.range(tr.dataset.hip),
          }));
          const m = { bust: this.value('bust'), waist: this.value('waist'), hip: this.value('hip') };
          const height = this.value('height');
          const weight = this.value('weight');
          const error = this.querySelector('[data-sf-error]');
          const hasBody = m.bust !== null || m.waist !== null || m.hip !== null;
          if (rows.length === 0 || (!hasBody && (height === null || weight === null))) {
            error.hidden = false;
            this.querySelector('[data-sf-result]').hidden = true;
            return;
          }
          error.hidden = true;

          let index = 0;
          let score = 0;
          if (hasBody) {
            const w = this.weights();
            let best = Infinity;
            rows.forEach((row, i) => {
              let total = 0;
              let used = 0;
              ['bust', 'waist', 'hip'].forEach((key) => {
                if (m[key] === null || !row[key]) return;
                const [lo, hi] = row[key];
                const mid = (lo + hi) / 2;
                const out = m[key] < lo ? lo - m[key] : m[key] > hi ? m[key] - hi : 0;
                total += w[key] * (out + Math.abs(m[key] - mid) * 0.15);
                used += w[key];
              });
              const s = used > 0 ? total / used : Infinity;
              if (s < best) {
                best = s;
                index = i;
              }
            });
            score = best;
          } else {
            const bmi = weight / Math.pow(height / 100, 2);
            const steps = [18.5, 20.5, 22.5, 25, 27.5];
            index = steps.filter((b) => bmi >= b).length;
            score = 3;
          }

          const fit = this.querySelector('[data-sf="fit"]').value;
          if (fit === 'fitted') index -= 1;
          if (fit === 'relaxed') index += 1;
          index = Math.max(0, Math.min(rows.length - 1, index));

          const row = rows[index];
          const match = Math.max(60, Math.min(98, Math.round(98 - score * 4)));
          this.recommended = row.label;
          this.querySelector('[data-sf-size]').textContent = row.label;
          this.querySelector('[data-sf-match]').textContent = `%${match}`;
          this.querySelector('[data-sf-bar]').style.width = `${match}%`;
          rows.forEach((r) => r.el.classList.toggle('on', r === row));

          const button = this.findSizeButton(row.label);
          this.querySelector('[data-sf-title]').textContent = button
            ? this.texts[fit] || this.texts.normal
            : this.texts.missing;
          this.querySelector('[data-sf-select]').hidden = !button || button.disabled;
          this.querySelector('[data-sf-result]').hidden = false;
        }

        findSizeButton(label) {
          const index = this.dataset.sizeIndex;
          const product = this.closest('mn-product');
          if (!product || index === '-1') return null;
          const aliases = String(label)
            .split('/')
            .map((a) => a.trim().toLowerCase())
            .filter(Boolean);
          return [...product.querySelectorAll(`[data-option="${index}"]`)].find((b) =>
            aliases.includes(String(b.dataset.value).trim().toLowerCase())
          );
        }

        selectSize() {
          const button = this.findSizeButton(this.recommended);
          if (button && !button.disabled) {
            button.click();
            button.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
